import React, { useEffect, useState } from 'react';

import { TCommentType } from '@entities/comment/model/types';
import { COMMENTS_CLOSED_EVENT_NAME, COMMENTS_OPEN_EVENT_NAME } from '@widgets/Comments/consts';
import { Comments } from '@widgets/Comments/ui/Comments';

interface ICommentsOpenEventDetail {
    positionGuid?: string;
    positionName?: string;
    commentType?: TCommentType;
    withChecklist?: boolean;
}

interface ICommentsModalPayload {
    positionGuid: string;
    positionName: string;
    commentType: TCommentType;
    withChecklist: boolean;
}

export const CommentsModalHost = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [modalPayload, setModalPayload] = useState<ICommentsModalPayload>({
        positionGuid: '',
        positionName: '',
        commentType: 'positionComment',
        withChecklist: true,
    });

    const handleClose = () => {
        window.dispatchEvent(
            new CustomEvent(COMMENTS_CLOSED_EVENT_NAME, {
                detail: {
                    positionGuid: modalPayload.positionGuid,
                    commentType: modalPayload.commentType,
                },
            })
        );
        setIsOpen(false);
    };

    useEffect(() => {
        const handleOpen = (event: Event) => {
            const customEvent = event as CustomEvent<ICommentsOpenEventDetail>;
            const nextPositionGuid = customEvent.detail?.positionGuid;

            if (!nextPositionGuid) {
                return;
            }

            setModalPayload({
                positionGuid: nextPositionGuid,
                positionName: customEvent.detail?.positionName || '',
                commentType: customEvent.detail?.commentType || 'positionComment',
                withChecklist: customEvent.detail?.withChecklist !== false,
            });
            setIsOpen(true);
        };

        window.addEventListener(COMMENTS_OPEN_EVENT_NAME, handleOpen as EventListener);

        return () => {
            window.removeEventListener(COMMENTS_OPEN_EVENT_NAME, handleOpen as EventListener);
        };
    }, []);

    return (
        <Comments
            isOpen={isOpen}
            onClose={handleClose}
            positionGuid={modalPayload.positionGuid}
            positionName={modalPayload.positionName}
            commentType={modalPayload.commentType}
            withChecklist={modalPayload.withChecklist}
        />
    );
};
